import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10bd2099"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-kt-menu-placement"]
const _hoisted_2 = { class: "menu-title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "rounded px-3 py-2 fs-6" }
const _hoisted_5 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_6 = {
  class: "language-select-menu menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 py-1",
  "data-kt-menu": "true"
}
const _hoisted_7 = ["dir"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      href: "#",
      class: "language-select-button btn btn-sm btn-white btn-active-white shadow-sm",
      "data-kt-menu-trigger": "click",
      "data-kt-menu-placement": 
      $setup.currentLanguageLocale.isRtl ? 'bottom-start' : 'bottom-end'
    ,
      "data-kt-menu-flip": "top-end"
    }, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("img", {
          class: "w-15px h-8px ms-2",
          src: $setup.currentLanguageLocale.flag
        }, null, 8, _hoisted_3),
        _createElementVNode("span", _hoisted_4, _toDisplayString($setup.currentLanguageLocale.label), 1),
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr072.svg" })
        ])
      ])
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.locales, (lang, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "menu-item px-3",
          key: `locale_${index}`,
          dir: lang.isRtl ? 'rtl' : 'ltr'
        }, [
          _createElementVNode("a", {
            onClick: ($event: any) => ($setup.setLang(lang.locale)),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-3 fs-6", { active: $setup.checkIfCurrentLanguage(lang.locale) }])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass([
            `language-flag${lang.isRtl ? '-rtl' : ''}`,
            'symbol symbol-20px',
          ])
            }, [
              _createElementVNode("img", {
                class: "w-15px h-8px rounded-0",
                src: lang.flag
              }, null, 8, _hoisted_9)
            ], 2),
            _createTextVNode(" " + _toDisplayString(lang.name), 1)
          ], 10, _hoisted_8)
        ], 8, _hoisted_7))
      }), 128))
    ])
  ], 64))
}